import { AlertTriangle } from 'lucide-react'
import { defineModule } from '@/shell/module-system'
import { UvivaExceptionQueuePage } from '../uviva/pages/UvivaExceptionQueuePage'

/**
 * Uviva Exception Queue — surfaced in the Admin nav section for SPI
 * operations/admin staff. Same page component as the Uviva module but
 * pinned under Admin so it doesn't require navigating into the Vendors
 * section and shows a badge count.
 */
export default defineModule({
  id: 'uviva-exceptions',
  name: 'Uviva Exceptions',
  shortName: 'Exceptions',
  icon: AlertTriangle,
  navSection: 'admin',
  navOrder: 60,
  urlNamespace: '/uviva/exception-queue',
  routes: [
    { path: '/', element: UvivaExceptionQueuePage, label: 'Uviva Exception Queue' },
  ],
  permissions: ['admin', 'operations', 'operations_logistics', 'purchasing'],
  densityDefault: 'comfortable',
  mobileStrategy: 'desktop-only',
  keyboardShortcut: 'g v e',

  commandPaletteEntries: [
    {
      label: 'Uviva Exception Queue',
      keywords: ['uviva', 'exception', 'queue', 'pending', 'review', 'post failed'],
      path: '/',
      group: 'modules',
    },
  ],
})
